// UAT #1837: a deploy replaces js/ and css/ (rsync --delete), so a tab opened before it still runs the
// old app.js and asks for chunk hashes that are gone. The lazy route import fails and the menu silently
// does nothing. On such a failure load the new build once, straight at the page that was asked for.

const KUNCI = 'accutrax-chunk-reload';

export function isChunkLoadError(err) {
  if (!err) return false;
  if (err.name === 'ChunkLoadError') return true;
  const msg = String(err.message || err);
  return /Loading (CSS )?chunk [\w-]+ failed/i.test(msg)
    || /Failed to fetch dynamically imported module/i.test(msg)
    || /Importing a module script failed/i.test(msg);
}

// True when the page should reload for this target. Only once per target until a navigation succeeds,
// so a chunk that is missing in the NEW build too cannot loop the reload.
export function harusMuatUlang(err, target, storage) {
  if (!isChunkLoadError(err)) return false;
  if (storage.getItem(KUNCI) === target) return false;
  storage.setItem(KUNCI, target);
  return true;
}

export function navigasiBerhasil(storage) {
  storage.removeItem(KUNCI);
}
